<template>
    <outboxCon :bg="bg">
        <div class="teacher-team">
            <app-title :main="main" :sub="sub"></app-title>
            <img class="teacher-img" :src="teacherUrl">
            <div class="teacher-des">
                <div class="teacher-bg">TEACHER</div>
                <div class="type-box">
                    <p class="team">{{typeTitle}}</p>
                    <p class="type">{{typeName}}</p>
                </div>
                <p class="type-des" v-html="typeDes"></p>
            </div>
        </div>
    </outboxCon>
</template>
<script>
export default {
  props: {
    teacherUrl: {
      type: String,
      default: ''
    },
    typeTitle: {
      type: String,
      default: ''
    },
    typeName: {
      type: String,
      default: ''
    },
    typeDes: {
      type: String,
      default: ''
    },
    main: {
      type: String,
      default: ''
    },
    sub: {
      type: String,
      default: ''
    },
    bg: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
    .teacher-team{
        width: $main-width;
        margin: 0 auto;
        margin-bottom: 70px;
        padding: 50px 87px 42px;
        position: relative;
        .teacher-img{
            width: 1106px;
            height: 495px;
        }
        .teacher-des{
            width:743px;
            height:211px;
            border-radius:20px;
            position: absolute;
            right: 65px;
            bottom: -63px;
            background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/teacher-bg.png');
            background-size: 100% 100%;
            padding: 30px 70px 15px 95px;
            text-align: left;
            .teacher-bg{
                width:314px;
                position: absolute;
                height:92px;
                font-size:66px;
                font-family:PingFangSC-Semibold,PingFang SC;
                font-weight:600;
                color:rgba(118,167,221,1);
                line-height:92px;
                top: 10px;
                opacity: 0.08;
            }
            .type-box{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                position: relative;
                z-index: 1;
                .team{
                    font-size:26px;
                    font-family:PingFangSC-Semibold,PingFang SC;
                    font-weight:600;
                    line-height:37px;
                    text-shadow:0px 10px 24px rgba(147,147,147,0.14);
                    margin-right: 30px;
                }
                .type{
                    font-family:PingFangSC-Medium,PingFang SC;
                    font-size:16px;
                    padding: 0px 22px;
                    background:rgba(38,143,255,0.1);
                    border-radius:13px;
                    color: #268FFF;
                    line-height: 26px;
                }
            }
            .type-des{
                font-family: PingFangSC-Regular;
                font-size: 18px;
                line-height: 25px;
                margin-top: 14px;
            }
        }
    }
</style>
